const breakpoints = [{
  label: '4K',
  width: 2560,
  cssClass: 'w-xl',
  related: [
    'w-xl',
    'w-ll',
    'w-l',
    'w-t',
    'w-ml',
    'w-mm',
    'w-ms'
  ]
}, {
  label: 'Laptop L',
  width: 1440,
  cssClass: 'w-ll',
  related: [
    'w-ll',
    'w-l',
    'w-t',
    'w-ml',
    'w-mm',
    'w-ms'
  ]
}, {
  label: 'Laptop',
  width: 1024,
  cssClass: 'w-l',
  related: [
    'w-l',
    'w-t',
    'w-ml',
    'w-mm',
    'w-ms'
  ]
}, {
  label: 'Tablet',
  width: 768,
  cssClass: 'w-t',
  related: [
    'w-t',
    'w-ml',
    'w-mm',
    'w-ms'
  ]
}, {
  label: 'Mobile L',
  width: 425,
  cssClass: 'w-ml',
  related: [
    'w-ml',
    'w-mm',
    'w-ms'
  ]
}, {
  label: 'Mobile M',
  width: 375,
  cssClass: 'w-mm',
  related: [
    'w-mm',
    'w-ms'
  ]
}, {
  label: 'Mobile S',
  width: 320,
  cssClass: 'w-ms',
  related: [
    'w-ms'
  ]
}]

export default breakpoints



// WEBPACK FOOTER //
// ./src/helpers/device-emulator-breakpoints.js